export default {"src":"/_next/static/media/MuteOff.efec0c6f.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};